// extracted by mini-css-extract-plugin
module.exports = {"ClickButton":"PopForm_ClickButton__jjKw5","Header":"PopForm_Header__VukNx"};